module.exports = __webpack_public_path__ + "c262404c8a3cbf5637124774cd4cd3bc.pdf";